import React from 'react';
import cn from 'classnames';

import { Icon } from 'components/shared/Icon';
import { Typography } from 'components/shared/Typography';

import { idxMap } from 'helpers/styleMapIdx';

import styles from './StatusTag.module.scss';

const VARIANTS = {
  default: styles.default,
  info: styles.info,
  success: styles.success,
  error: styles.error,
  warning: styles.warning,
  secondary: styles.secondary,
  neutral: styles.neutral,
};

const StatusTag = ({
  className,
  variant,
  icon,
  children,
}: {
  className: any;
  variant: any;
  icon?: string;
  children: any;
}) => (
  <div
    className={cn(
      styles.tag,
      idxMap(VARIANTS as Record<string, string>, variant),
      { [styles.tagWithIcon]: icon },
      className,
    )}
  >
    {icon ? <Icon className={styles.icon} name={icon} /> : null}
    <Typography
      className={styles.text}
      variant="body3"
      weight="medium"
      mode="compact"
    >
      {children}
    </Typography>
  </div>
);

export default React.memo(StatusTag) as any;
